import { CoordNotesRepositoryFactory } from "../../adapters/driven/repositories/coordNotesRepository";

// Re-export from a path that exists at build time — the factory is in driven/repositories
// We import the factory type via the actual file to avoid path gymnastics.

export const CoordNotesServiceImplFactory = ({
  coordNotesRepository,
}: {
  coordNotesRepository: ReturnType<typeof CoordNotesRepositoryFactory>;
}) => {
  const getNotes = async ({
    clinicId,
    patientId,
    limit,
    offset,
  }: {
    clinicId: number;
    patientId: number;
    limit?: number;
    offset?: number;
  }) => {
    try {
      const result = await coordNotesRepository.getNotesAPI({
        clinic_id: clinicId,
        patient_id: patientId,
        limit,
        offset,
      });
      return { success: true as const, data: result };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  const createNote = async ({
    clinicId,
    patientId,
    noteText,
  }: {
    clinicId: number;
    patientId: number;
    noteText: string;
  }) => {
    try {
      const result = await coordNotesRepository.createNoteAPI({
        clinic_id: clinicId,
        patient_id: patientId,
        note_text: noteText,
      });
      return { success: true as const, data: result };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  const patchNote = async ({
    clinicId,
    patientId,
    noteId,
    noteText,
    status,
  }: {
    clinicId: number;
    patientId: number;
    noteId: number;
    noteText?: string;
    status?: 0 | 1;
  }) => {
    try {
      const result = await coordNotesRepository.patchNoteAPI({
        clinic_id: clinicId,
        patient_id: patientId,
        note_id: noteId,
        note_text: noteText,
        status,
      });
      return { success: true as const, data: result };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  return { getNotes, createNote, patchNote };
};
